import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CoreModule} from "./core/core.module";
import {GraphQLModule} from './graphql.module';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule} from "@angular/forms";
import {AuthInterceptor} from "./core/auth/auth.interceptor";
import {LanguageModule} from "./modules/language/language.module";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {httpTranslateLoader} from "./core/translate/translate-loader-factory";
import {CommonModule} from "@angular/common";
import {AngularSvgIconModule} from "angular-svg-icon";
import {AuthenticateModule} from "./modules/authenticate/authenticate.module";
import {DataService} from "./core/data.service";
import {AuthService} from "./core/auth/auth.service";
import {MAT_DATE_LOCALE} from "@angular/material/core";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    GraphQLModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    CoreModule,
    LanguageModule,
    AuthenticateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    CoreModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: TranslateLoader,
      useFactory: httpTranslateLoader,
      deps: [HttpClient]
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    TranslateService,
    DataService,
    AuthService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

